// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import requestDocumentEntity from './entities/request-document.json';
import requestDocumentMenu from '../pages/request-document/menu.json';
import requestDocumentFullForm from '../pages/request-document/forms/full.json';
import requestDocumentContextForm from '../pages/request-document/forms/context.json';
import requestDocumentMiniForm from '../pages/request-document/forms/mini.json';
import requestDocumentLookupForm from '../pages/request-document/forms/lookup.json';
import requestDocumentTableView from '../pages/request-document/views/table.json';
import requestDocumentCardsView from '../pages/request-document/views/cards.json';
import requestDocumentCalendarView from '../pages/request-document/views/calendar.json';
import requestDocumentDashboardView from '../pages/request-document/views/dashboard.json';

/** Тип запису «Документ запиту» зі сторінками пакета: меню, форми та подання з pages/request-document/. */
export const requestDocumentDefinition: IRecordTypeDefinition = {
  ...requestDocumentEntity,
  views: assembleViewSet({
      table: requestDocumentTableView,
      cards: requestDocumentCardsView,
      calendar: requestDocumentCalendarView,
      dashboard: requestDocumentDashboardView,
  }),
  form: requestDocumentFullForm,
  forms: { full: requestDocumentFullForm, context: requestDocumentContextForm, mini: requestDocumentMiniForm, lookup: requestDocumentLookupForm },
  menu: requestDocumentMenu,
} as IRecordTypeDefinition;
